export default {
    bindings: {
        onSave: '&',
        onSuccess: '&',
        onError: '&',
        saving: '=?',
        form: '=?'
    },
    transclude: {
        buttons: '?formButtons'
    },
    controller: 'apiFormController',
    template: `
    <form name="$ctrl.form" ng-submit="$ctrl.handleSave()" novalidate>
      <div class="alert alert--fail" ng-if="$ctrl.form.$api.$error">
        <span ng-repeat="error in $ctrl.form.$api.$error">
          {{ error }}
        </span>
      </div>

      <ng-transclude></ng-transclude>

      <div class="c-form__actions" ng-transclude ng-transclude-slot="buttons">
        <button class="button round" type="submit" ng-disabled="$ctrl.saving || $ctrl.form.$invalid">
          Submit <spinner ng-if="$ctrl.saving" />
        </button>
      </div>
    </form>
  `
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/api.form.component.js